import {all, fork, put, takeLatest} from "redux-saga/effects";
import {
  cancelAccountSubscriptionSuccess,
  createAccountSubscriptionSuccess,
  deleteAccountSubscriptionSuccess,
  getAccountSubscriptionSuccess,
  getAllAccountSubscriptions,
  getAllAccountSubscriptionsSuccess,
  reactivateAccountSubscriptionSuccess,
  setLoadingInvisible,
  updateAccountSubscriptionSuccess,
} from 'redux/actions';
import {
  ACCOUNT_SUBSCRIPTIONS_ALL,
  ACCOUNT_SUBSCRIPTIONS_CANCEL,
  ACCOUNT_SUBSCRIPTIONS_CREATE,
  ACCOUNT_SUBSCRIPTIONS_DELETE,
  ACCOUNT_SUBSCRIPTIONS_GET,
  ACCOUNT_SUBSCRIPTIONS_REACTIVATE,
  ACCOUNT_SUBSCRIPTIONS_UPDATE
} from "redux/constants/AccountSubscriptions"
import EstService from "services/EstService"
import NotificationService from "services/NotificationService";

export function* getAccountSubscriptions() {
  yield takeLatest(ACCOUNT_SUBSCRIPTIONS_ALL, function* () {
    try {
      const subscriptions = yield EstService.getAccountSubscriptions();
      yield put(getAllAccountSubscriptionsSuccess(subscriptions.data));
      yield put(setLoadingInvisible());
    } catch (err) {
      console.log(err);
      yield put(setLoadingInvisible());
    }
  })
}

export function* getAccountSubscription() {
  yield takeLatest(ACCOUNT_SUBSCRIPTIONS_GET, function* ({ subscriptionId }) {
    try {
      const subscription = yield EstService.getAccountSubscription(subscriptionId);
      yield put(getAccountSubscriptionSuccess(subscription.data));
    } catch (err) {
      console.log(err)
    }
  })
}

export function* createAccountSubscription() {
  yield takeLatest(ACCOUNT_SUBSCRIPTIONS_CREATE, function* ({ data, history }) {
    try {
      const subscription = yield EstService.createAccountSubscription(data);
      yield put(createAccountSubscriptionSuccess(subscription.data));
      history.push(`/app/subscriptions/${subscription.data.id}`);
    } catch (err) {
      console.log(err)
    }
  })
}

export function* updateAccountSubscription() {
  yield takeLatest(ACCOUNT_SUBSCRIPTIONS_UPDATE, function* ({ subscriptionId, data, history }) {
    try {
      const subscription = yield EstService.updateAccountSubscription(subscriptionId, data);
      yield put(updateAccountSubscriptionSuccess(subscriptionId, subscription.data));
      history.push(`/app/subscriptions/${subscriptionId}`);
    } catch (err) {
      console.log(err)
    }
  })
}

export function* deleteAccountSubscription() {
  yield takeLatest(ACCOUNT_SUBSCRIPTIONS_DELETE, function* ({ subscriptionId, history }) {
    try {
      yield EstService.deleteAccountSubscription(subscriptionId);
      yield put(deleteAccountSubscriptionSuccess(subscriptionId));
      history.push(`/app/subscriptions`);
    } catch (err) {
      console.log(err)
    }
  })
}

export function* cancelAccountSubscription() {
  yield takeLatest(ACCOUNT_SUBSCRIPTIONS_CANCEL, function* ({ id, reason }) {
    try {
      const res = yield EstService.cancelAccountSubscription(id, reason);
      if (res && res.message) {
        NotificationService.success(res.message);
      }
      yield put(cancelAccountSubscriptionSuccess());
      yield put(getAllAccountSubscriptions());
    } catch (err) {
      console.log(err)
    }
  })
}

export function* reactivateAccountSubscription() {
  yield takeLatest(ACCOUNT_SUBSCRIPTIONS_REACTIVATE, function* ({ id }) {
    try {
      const res = yield EstService.reactivateAccountSubscription(id);
      if (res && res.data) {
        NotificationService.success(res.data);
      }
      yield put(reactivateAccountSubscriptionSuccess());
      yield put(getAllAccountSubscriptions());
    } catch (err) {
      console.log(err)
    }
  })
}

export default function* accountSubscriptionsSaga() {
  yield all([
    fork(getAccountSubscriptions),
    fork(createAccountSubscription),
    fork(getAccountSubscription),
    fork(updateAccountSubscription),
    fork(deleteAccountSubscription),
    fork(cancelAccountSubscription),
    fork(reactivateAccountSubscription),
  ]);
}